import { Navigate, Outlet, useLocation } from "react-router-dom";

import { useAuth } from "../../context/AuthProvider";
import { useLanguage } from "../../context/LanguageProvider";
import { ROUTES } from "../../shared/constants/routes";
import StatusMessage from "../../shared/components/elements/StatusMessage";
import PageLayout from "../../shared/components/layout/PageLayout";

// Layout route: everything nested inside requires a logged-in user
const RequireAuth = () => {
    const { isAuthenticated, loading } = useAuth();
    const { lang, t } = useLanguage();
    const location = useLocation();

    // Wait for the session check, otherwise logged-in users get bounced to the login page
    if (loading) {
        return (
            <PageLayout>
                <StatusMessage>{t.utils.loading}</StatusMessage>
            </PageLayout>
        );
    }

    if (!isAuthenticated) {
        // After login the user returns to the page they wanted (AuthPage validates this value)
        const returnTo = encodeURIComponent(location.pathname + location.search);
        return <Navigate to={`${ROUTES.auth(lang)}?redirect=${returnTo}`} replace />;
    }

    return <Outlet />;
};

export default RequireAuth;